import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/shared/components/settings/loading/loading.service';
import { ToasterService } from 'src/app/shared/components/toaster/toaster.service';
import { LayoutVisaoEnum } from 'src/app/shared/enum/layout-visao.enum';
import { IUser } from 'src/app/shared/models/user.model';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { LayoutService } from 'src/app/shared/services/layout/layout.service';
import { UserService } from 'src/app/shared/services/user/user.service';
import { ModalUsersService } from '../../components/modal-users/modal-users.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, skip } from 'rxjs/operators';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {

  public users: Array<IUser>;
  public onlyOne: boolean;
  public idUserAuth: number;
  public isVisaoTablet: boolean = false;
  public isVisaoMobile: boolean = false;

  public filtroUsuario = new BehaviorSubject<string>('');
  private filtroUsuario$: Subscription;

  constructor(
    private userService: UserService,
    private modalUserService: ModalUsersService,
    private authService: AuthService,
    private layoutVisao: LayoutService,
    private loadingService: LoadingService,
    private toastrService: ToasterService
  ) { }

  public async ngOnInit(): Promise<void> {
    this.initSubscriptions();
    this.isVisaoTablet = this.layoutVisao.setLayoutTela(LayoutVisaoEnum.TABLET);
    this.isVisaoMobile = this.layoutVisao.setLayoutTela(LayoutVisaoEnum.MOBILE)

    this.getUsers();
  }

  public ngOnDestroy(): void {
    this.destroySubscriptions();
  }

  private initSubscriptions(): void {
    this.filtroUsuario$ = this.filtroUsuario.pipe(
      skip(1), // Quando e feito o subscribe ele faz um primeiro emit, entao ele pula esse emit.
      debounceTime(400),
      distinctUntilChanged(),
    ).subscribe(async () => {
      this.getUsers();
    });
  }

  private destroySubscriptions(): void {
    this.filtroUsuario$.unsubscribe();
  }


  private async getUsers() {
    try {
      this.loadingService.showLoader();
      this.users = await this.userService.getUsers(this.filtroUsuario.value);

      this.orderUserByName();
      const user = this.authService.getUserLocal();
      if (user === null) {
        throw new Error('Usuário não autenticado');
      }
      this.idUserAuth = user.id;

      this.loadingService.hideLoader();
    } catch (error) {
      this.toastrService.showError('Não foi possível carregar a lista de usuários');
      this.loadingService.hideLoader();
    }
  }

  private orderUserByName(): void {
    this.users.sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      return 0;
    });
  }

  public async addUser(): Promise<void> {
    const resultCreateUser = await this.modalUserService.open();
    if (resultCreateUser === undefined) {
      return;
    }
    this.users.push(resultCreateUser);
    this.orderUserByName();
  }

  public onDeleteUser(pUser: IUser): void {
    this.users = this.users.filter(user => user.id !== pUser.id);
  }

  public onSearchEvent(pEvent: string) {

  }
}
